import React from 'react';
import { Select, SelectProps } from 'evergreen-ui';
import { convertSelectedValue, SelectedValue } from './utils';

export type StatusSelectValueProps<T extends SelectedValue> = {
  selected: T
  onSelect?: (selectedStatus: T) => void,
}
type StatusSelectProps<T extends SelectedValue> = Omit<SelectProps, 'onSelect'> &
StatusSelectValueProps<T> & {
  statusDescription: {
    [key: string]: string
    unknown: string,
  },
  allValuesLabel: string,
}

export function StatusSelect<T extends SelectedValue>({
  selected,
  onSelect,
  statusDescription,
  allValuesLabel = 'ВСЕ',
  ...props
}:StatusSelectProps<T>) {
  const selectedValue = selected === undefined ? '-1' : selected.toString();
  const onChangeSelected = (event: React.ChangeEvent<HTMLSelectElement>) => {
    onSelect && onSelect(convertSelectedValue(event.target.value) as T);
  };
  return (
    <Select value={selectedValue} onChange={onChangeSelected} maxWidth="max-content" {...props}>
      <option value="-1">{allValuesLabel.toUpperCase()}</option>
      {
        Object.entries(statusDescription).map(([value, description]) => (
          <option key={value} value={value === 'unknown' ? '0' : value}>{description}</option>
        ))
      }
    </Select>
  );
}
export const MemoStatusSelect = React.memo(StatusSelect);
MemoStatusSelect.displayName = 'MemoStatusSelect';
export default StatusSelect;
